import type { Expense, ExpenseSummary, CreateExpenseInput } from './types'
import { USE_MOCK_API } from './httpClient'
import {
  listExpensesMock,
  getSummaryMock,
  createExpenseMock,
  updateExpenseMock,
  deleteExpenseMock,
} from './expenses.mock'
import {
  listExpensesHttp,
  getSummaryHttp,
  createExpenseHttp,
  updateExpenseHttp,
  deleteExpenseHttp,
} from './expenses.http'

export function listExpenses(tripId: string): Promise<Expense[]> {
  return USE_MOCK_API ? listExpensesMock(tripId) : listExpensesHttp(tripId)
}

export function getExpenseSummary(tripId: string): Promise<ExpenseSummary> {
  return USE_MOCK_API ? getSummaryMock(tripId) : getSummaryHttp(tripId)
}

export function createExpense(tripId: string, input: CreateExpenseInput): Promise<Expense> {
  return USE_MOCK_API ? createExpenseMock(tripId, input) : createExpenseHttp(tripId, input)
}

export function updateExpense(
  tripId: string,
  expId: string,
  input: Partial<CreateExpenseInput>,
): Promise<Expense> {
  return USE_MOCK_API
    ? updateExpenseMock(tripId, expId, input)
    : updateExpenseHttp(tripId, expId, input)
}

export function deleteExpense(tripId: string, expId: string): Promise<void> {
  return USE_MOCK_API ? deleteExpenseMock(tripId, expId) : deleteExpenseHttp(tripId, expId)
}
